var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "TcInscriptionError inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-xl w-full px-5"
    },
    [
      _c("div", { staticClass: "py-10" }, [
        _c("div", { staticClass: "flex flex-col items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-red-400 text-white"
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d:
                        "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mt-10 text-2xl text-center" }, [
            _vm._v(
              "Se ha producido un error mientras se intentaba reservar el evento."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-5 text-gray-500 text-center" }, [
            _vm._v(_vm._s(_vm.$parent.error_msg))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "w-full max-w-sm mt-10 bg-red-400",
              on: {
                click: function($event) {
                  return _vm.$parent.setPage(
                    _vm.$root.user ? "events-my-calendar" : "login-public"
                  )
                }
              }
            },
            [_vm._v("Continuar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "w-full max-w-sm mt-5 btn-secondary",
              on: {
                click: function($event) {
                  return _vm.$root.logOut()
                }
              }
            },
            [_vm._v("Cerar sesión")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }